import { setBearerToken }  from '../../http'

export const setHeaderToken = token => setBearerToken(token)
export const getLocalToken = () => localStorage.getItem('token')
export const deleteLocalToken = () => localStorage.removeItem('token')
export const setLocalToken = token => localStorage.setItem('token', token)


export const getLocalDomain = () => localStorage.getItem('domain')
export const deleteLocalDomain = () => localStorage.removeItem('domain')
export const setLocalDomain = domain => localStorage.setItem('domain', domain)

export const getLocalUser = () => localStorage.getItem('user')
export const deleteLocalUser = () => localStorage.removeItem('user')
// Campos que não precisam ficar no navegador (legíveis por qualquer script da página)
const CAMPOS_SENSIVEIS = [
    'password', 'api_token', 'remember_token', 'mercpago_cartao_token', 'id_firebase',
    'banco', 'agencia', 'conta', 'rg', 'user_criacao_ip', 'user_modificacao_ip',
    'comprovante_rg_frente', 'comprovante_rg_verso', 'comprovante_cnh', 'comprovante_endereco',
]

export const semCamposSensiveis = user => {
    if (!user || typeof user !== 'object') return user
    const copia = { ...user }
    CAMPOS_SENSIVEIS.forEach(campo => { delete copia[campo] })
    return copia
}

export const setLocalUser = user => localStorage.setItem('user', JSON.stringify(semCamposSensiveis(user)))

// Metadados do token: quando foi emitido e por quanto tempo é válido
export const setLocalTokenMeta = (expiresInMinutes) => {
    const meta = {
        issued_at: Date.now(),
        expires_ms: expiresInMinutes * 60 * 1000,
    }
    localStorage.setItem('token_meta', JSON.stringify(meta))
}

export const getLocalTokenMeta = () => {
    const raw = localStorage.getItem('token_meta')
    return raw ? JSON.parse(raw) : null
}

export const deleteLocalTokenMeta = () => localStorage.removeItem('token_meta')

/**
 * Retorna true se o token vai expirar dentro de `thresholdMinutes` minutos.
 * Usado para acionar o refresh proativo antes de chegar ao 401.
 */
export const isTokenExpiringSoon = (thresholdMinutes = 10) => {
    const meta = getLocalTokenMeta()
    if (!meta) return true
    const expiresAt = meta.issued_at + meta.expires_ms
    const threshold = thresholdMinutes * 60 * 1000
    return Date.now() >= expiresAt - threshold
}

/**
 * Retorna true se o token já expirou (sem margem de tolerância).
 * Usado em ActionCheckToken para rejeitar sessões antigas ao abrir a aplicação.
 */
export const isTokenExpired = () => {
    const meta = getLocalTokenMeta()
    if (!meta) return true
    return Date.now() >= meta.issued_at + meta.expires_ms
}